import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';

import {MyApp} from './app.component';
import {HomePageModule} from '../pages/home/home.module';
import {FirebaseProvider} from '../providers/firebase/firebase';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {AngularFireModule} from '@angular/fire';
import {HttpProvider} from '../providers/http/http';
import {NotificationWebProvider} from '../providers/notification-web/notification-web';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {HttpModule} from '@angular/http';
import {MapdirectionsProvider} from '../providers/mapdirections/mapdirections';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {AppState} from './app.global';

//BASE DEV

/* const firebaseConfig = {
  apiKey: 'AIzaSyCAqFbfi2tvi28ZWeUuMAFtBGysSe9ZICk',
  authDomain: 'orion-e6d6cd.firebaseapp.com',
  databaseURL: 'https://asistco-test.firebaseio.com',
  projectId: 'orion-6d6cd',
  storageBucket: 'asistco-test',
  messagingSenderId: '49065992138'
}; */


//BASE PROD

const firebaseConfig = {
  apiKey: 'AIzaSyCAqFbfi2tvi28ZWeUuMAFtBGysSe9ZICk',
  authDomain: 'orion-6d6cd.firebaseapp.com',
  databaseURL: 'https://orion-6d6cd.firebaseio.com/',
  projectId: 'orion-6d6cd',
  storageBucket: 'orion-6d6cd',
  messagingSenderId: '49065992138'
};


@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(firebaseConfig),
    HttpClientModule,
    HttpModule,
    HomePageModule,
    BrowserAnimationsModule,
    BrowserModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    FirebaseProvider,
    HttpProvider,
    NotificationWebProvider,
    MapdirectionsProvider,
    AppState
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts